import { persistentClipsDns, salesUrl } from '@/environment';
import { VideoHelper } from '@/pages/avatar/components/VideoHelper';
import { useAnalytics } from '@/services/analytics';
import styled from '@emotion/styled';
import { AvatarType } from '../../common';
import { useCreateAvatarStore } from '../../common/context';
import { StepTitle } from '../Styled/Title';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px 24px 40px;
    gap: 24px;
    align-items: center;
    margin: 0 auto;
    height: calc(100vh - 96px);
    width: 100%;
    max-width: 900px;
`;

const Title = styled(StepTitle)`
    margin-bottom: 16px;
`;

const StyledVideo = styled.video`
    width: 100%;
    border-radius: 22px;
`;

const AdditionalInfo = styled.p`
    color: ${({ theme }) => theme.colors.secondary[700]};
    font-size: 16px;
    letter-spacing: 0.15px;
    font-weight: 400;
`;

const AdditionalInfoLink = styled.a`
    font-weight: bold;
    text-decoration: underline;

    color: ${({ theme }) => theme.colors.secondary[900]};
    :hover {
        color: ${({ theme }) => theme.colors.secondary[900]};
    }

    outline: none;
`;

interface Props {
    instructionsFileLink?: string;
}

export const InstructionStep = ({ instructionsFileLink }: Props) => {
    const mixpanel = useAnalytics();
    const createAvatarStore = useCreateAvatarStore();

    const isExpress = createAvatarStore.type === AvatarType.Express;
    const instructionFileName = isExpress ? '/D_ID_express-avatar' : '/D_ID_DVP-Avatar';

    const handleStudioAvatarClick = () => {
        mixpanel?.track('contact', { event: 'click', from: 'express-avatar' });
        window.open(salesUrl, '_blank');
    };

    return (
        <Container>
            <Title>Overview</Title>
            <StyledVideo
                poster={encodeURI(persistentClipsDns + instructionFileName + '.png')}
                src={encodeURI(persistentClipsDns + instructionFileName + '.mp4')}
                controls
                playsInline
            />
            <VideoHelper />
            {instructionsFileLink && (
                <AdditionalInfo>
                    View details instruction{' '}
                    <AdditionalInfoLink href={instructionsFileLink} target="_blank" rel="noopener noreferrer">
                        here
                    </AdditionalInfoLink>
                </AdditionalInfo>
            )}
            {isExpress && (
                <AdditionalInfo>
                    Want to create a Studio Avatar?{' '}
                    <AdditionalInfoLink target="_blank" rel="noopener noreferrer" onClick={handleStudioAvatarClick}>
                        Contact us
                    </AdditionalInfoLink>
                </AdditionalInfo>
            )}
        </Container>
    );
};
